import { controller, target } from '@github/catalyst';
import { inputUrlIsValid } from '../forms/validation';

@controller('url-field')
class UrlFieldElement extends HTMLElement {
  @target declare input: HTMLInputElement;
  @target declare copy: HTMLButtonElement;
  @target declare anchor: HTMLAnchorElement;
  disconnected?: AbortController;

  connectedCallback() {
    this.disconnected = new AbortController();
    const options = { signal: this.disconnected.signal };
    this.input.addEventListener('change', () => this.update(), options);
    this.input.addEventListener('input', () => this.update(), options);
    this.update();
  }

  disconnectedCallback() {
    this.disconnected?.abort();
  }

  update() {
    const valid = inputUrlIsValid(this.input);
    this.anchor.ariaDisabled = this.copy.ariaDisabled = String(!valid);
    if (valid) {
      this.anchor.href = this.input.value;
    } else {
      this.anchor.removeAttribute('href');
    }
    this.copy.tabIndex = valid ? 0 : -1;
  }
}

declare global {
  interface Window {
    UrlFieldElement: typeof UrlFieldElement;
  }
  interface HTMLElementTagNameMap {
    'url-field': UrlFieldElement;
  }
}
